import { COOKIE_ICON } from "@constants/cookies";
import { CookieConsentIconProps } from "@models/shared/shared.model";

const CookieConsentIcon = ({ onExpand }: CookieConsentIconProps) => {
  const handleClick = () => {
    onExpand();
  };

  return (
    <button
      className="fg-cookie-icon-button"
      onClick={handleClick}
      type="button"
      aria-label="Cookie settings"
    >
      <img src={COOKIE_ICON} alt="Cookie Icon" className="fg-cookie-icon-svg" />
    </button>
  );
};

export default CookieConsentIcon;
